import { Controller } from '@hotwired/stimulus';
require('prismjs');
require('prismjs/plugins/normalize-whitespace/prism-normalize-whitespace');

export default class extends Controller {
  connect() {
    Prism.highlightAll();
  }
}
